import React, { useContext } from 'react'
import { FlightDropdownOption as SelectOption } from 'components/Flights/types'

import Modal from 'LuxKit/Modal/Modal'
import RadioGroup from 'LuxKit/Radio/RadioGroup'
import FlightDropdownOption from 'components/Flights/FlightSorting/FlightDropdownToggle/FlightDropdownOption'
import ModalContext from 'contexts/ModalContext'
import TextButton from 'LuxKit/Button/TextButton'
import DropdownChevron from 'LuxKit/Dropdown/DropdownChevron'

interface Props extends Utils.PropsWithDataAttributes {
  options: Array<SelectOption>;
  selectedOption: SelectOption;
  className?: string;
  title: string;
  onOptionChange: (option: SelectOption) => void;
  name: string;
}

function FareDropdownMobile(props: Props) {
  const { options, selectedOption, onOptionChange, title, name, ...rest } = props
  const showModal = useContext(ModalContext)

  const onShowFareTypes = () => {
    showModal(
      <Modal title={title}>
        <RadioGroup>
          {options.map((option) => (
            <FlightDropdownOption
              key={option.value}
              defaultChecked={option === selectedOption}
              onChange={onOptionChange}
              option={option}
              name={name}
            />
          ))}
        </RadioGroup>
      </Modal>,
    )
  }

  return (
    <TextButton
      {...rest}
      kind="tertiary"
      endIcon={<DropdownChevron />}
      onClick={onShowFareTypes}
    >
      {selectedOption.label}
    </TextButton>
  )
}

export default FareDropdownMobile
